import React from 'react';
import '../styles/video.css';

function VideoSection() {
  return (
    <section className="video-section">
      <div className="video-container">
        <div className="video-header">
          <span className="video-badge">Watch</span>
          <h2 className="video-title">EA SPORTS FC 26 | Official Trailer</h2>
          <p className="video-subtitle">See the action! Experience more ways to win for the club in EA SPORTS FC™ 25. Team up with friends in your favourite modes.</p>
        </div>
        <div className="video-wrapper">
          <iframe
            className="youtube-video"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/TSi0iJYSQ24?si=Uo6ze5byGxLZv_W6&amp;controls=0"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default VideoSection; 